import React from 'react';
import set from "lodash/set";
import { toast } from 'react-toastify';
import { faArrowDown } from "@fortawesome/pro-solid-svg-icons/faArrowDown";
import { faArrowUp } from "@fortawesome/pro-solid-svg-icons/faArrowUp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import ErrorToast from 'Components/Partials/Toastify/ErrorToast';
import SuccessToast from 'Components/Partials/Toastify/SuccessToast';

import { Modal } from 'Services';

export default class Base extends React.Component {
    /**
     * @method handleOrderBy
     * @param {string} column
     * @param {undefined|function} cb
     */
    handleOrderBy = (column, cb = undefined) => {
        let { order } = this.state;

        if (order.column === column) {
            order.direction = order.direction === 'asc' ? 'desc' : 'asc';
        } else {
            order = {
                column,
                direction: 'asc',
            };
        }

        this.setState({
            order,
        }, () => {
            if (cb !== undefined) {
                cb();
            }

            this.updateLocationState();
        });
    };

    /**
     * @method handleFormInput
     * @param {string} name
     * @param {any} value
     * @param {function} [callable]
     */
    handleFormInput = (name, value, callable) => {
        const form = { ...this.state.form };

        set(form, name, value);

        this.setState({
            form,
        }, () => {
            if (callable !== undefined) {
                callable();
            }
        });
    };

    /**
     * @method handleSetFilter
     * @param {string} searchTerm
     * @param {string} field
     * @param {function} [callable]
     */
    handleSetFilter = (searchTerm, field, callable = undefined) => {
        const filters = { ...this.state.filters };
        filters[field] = searchTerm;

        this.setState({
            filters,
        }, () => {
            if (callable !== undefined) {
                callable();
            }

            this.updateLocationState();
        });
    };

    /**
     * @method updateLocationState
     */
    updateLocationState = () => {
        if (this.props.history) {
            this.props.history.push({
                pathname: this.props.location.pathname,
                state: this.locationStateKey ? {
                    ...this.props.location.state,
                    [this.locationStateKey]: this.state,
                } : this.state,
            });
        }
    };

    /**
     * @method handleTabChange
     * @param {string} tab
     */
    handleTabChange = (tab) => {
        this.setState({
            tab,
        }, () => {
            if (this.pushHistory !== undefined) {
                this.pushHistory();
            }
        });
    };

    /**
     * @method handleSubmit
     * @param e
     */
    handleSubmit = async (e) => {
        if (e !== undefined) {
            e.preventDefault();
        }

        if (this.props.onSubmit !== undefined) {
            const data = this.getFormData !== undefined ? this.getFormData() : this.state.form;

            const submit = await this.props.onSubmit(data);

            if (submit) {
                this.resetForm();
            }
        }
    };

    /**
     * @method working
     * @param {boolean} working
     */
    working = (working = true) => {
        this.setState({
            working: working,
            alert: null,
        });
    };

    /**
     * @method formErrors
     * @param {string} message
     * @param {any} [errors]
     */
    formErrors = (message, errors) => {
        this.setState({
            alert: {
                type: 'error',
                message,
                errors,
            },
            working: false,
        });
    };

    /**
     * @method formSuccess
     * @param {string} message
     */
    formSuccess = (message) => {
        this.setState({
            alert: {
                type: 'success',
                message,
            },
            working: false,
        });
    };

    /**
     * @method resetForm
     */
    resetForm = () => {
        if (this.initialForm !== undefined) {
            this.setState({
                form: this.initialForm,
            });

            return;
        }

        const { form } = this.state;

        for (const field in form) {
            if (!form.hasOwnProperty(field)) continue;

            form[field] = '';
        }

        this.setState({
            form,
        });
    };

    /**
     * @method toastSuccess
     * @param {string} message
     */
    toastSuccess = (message) => {
        toast(<SuccessToast body={message}/>);

        this.setState({
            working: false,
        });
    };

    /**
     * @method toastError
     * @param {string} message
     */
    toastError = (message) => {
        toast(<ErrorToast body={message}/>);

        this.setState({
            working: false,
        });
    };

    /**
     * @method defaultToastrError
     */
    defaultToastrError = () => {
        this.toastError(
            'Sorry, there was a problem processing your request. Please try again',
        );

        this.setState({
            working: false,
        });
    };

    // Default Handlers
    /**
     * @method handleOpenCreate
     */
    handleOpenCreate = (props) => {
        if (props === undefined && this.getModalData !== undefined) {
            props = {
                ...this.getModalData(),
            };
        }

        Modal.open('createModal', {
            component: this.createModal,
            props: props ?? {},
        });
    };

    /**
     * @method handleEdit
     */
    handleOpenEditModal = (props) => {
        if (props === undefined && this.getModalData !== undefined) {
            props = {
                ...this.getModalData(),
            };
        }

        Modal.open('editModal', {
            component: this.editModal,
            props,
        });
    };

    handleOpenViewModal = (props) => {
        if (props === undefined && this.getModalData !== undefined) {
            props = {
                ...this.getModalData(),
            };
        }

        Modal.open('viewModal', {
            component: this.viewModal,
            props,
        });
    };

    /**
     * @method handleAskToDelete
     */
    handleAskToDelete = (props) => {
        if (props === undefined && this.getModalData !== undefined) {
            props = {
                ...this.getModalData(),
            };
        }

        Modal.open('DeleteModal', {
            component: this.deleteModal,
            props,
        });
    };

    /**
     * @method renderOrderIcon
     * @param {string} column
     * @return {JSX.Element}
     */
    renderOrderIcon = (column) => {
        const { order } = this.state;

        return (
            <>
                {order.column === column && (
                    <FontAwesomeIcon icon={
                        order.direction === 'asc' ? faArrowDown : faArrowUp
                    } className="ml-1"/>
                )}
            </>
        );
    };
}
